import React from "react";
import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";
import { AYLAR } from "@/lib/api";

const setPeriod = (y, a) => {
  window.dispatchEvent(new CustomEvent("bordromat:setYil", { detail: y }));
  window.dispatchEvent(new CustomEvent("bordromat:setAy", { detail: a }));
};

export function PayrollPeriodFilter({ yil, ay }) {
  const thisYear = new Date().getFullYear();
  const years = [];
  for (let y = thisYear + 1; y >= 2022; y--) years.push(y);
  const shift = (d) => {
    const idx = yil * 12 + (ay - 1) + d;
    setPeriod(Math.floor(idx / 12), (idx % 12) + 1);
  };
  const sel = "bg-white border border-slate-300 rounded-md px-2.5 py-1.5 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-slate-900";
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-3 flex items-center gap-2 flex-wrap" data-testid="payroll-period-filter">
      <CalendarDays size={16} className="text-slate-500" />
      <span className="text-sm font-bold text-slate-900 mr-1">Bordro Dönemi</span>
      <button type="button" onClick={() => shift(-1)} data-testid="payroll-period-prev" title="Önceki ay"
        className="w-8 h-8 grid place-items-center rounded-md border border-slate-200 hover:bg-slate-100 transition-colors">
        <ChevronLeft size={15} />
      </button>
      <select value={ay} onChange={(e) => setPeriod(yil, Number(e.target.value))} className={sel} data-testid="payroll-period-month">
        {AYLAR.map((m) => <option key={m.v} value={m.v}>{m.n}</option>)}
      </select>
      <select value={yil} onChange={(e) => setPeriod(Number(e.target.value), ay)} className={sel} data-testid="payroll-period-year">
        {years.map((y) => <option key={y} value={y}>{y}</option>)}
      </select>
      <button type="button" onClick={() => shift(1)} data-testid="payroll-period-next" title="Sonraki ay"
        className="w-8 h-8 grid place-items-center rounded-md border border-slate-200 hover:bg-slate-100 transition-colors">
        <ChevronRight size={15} />
      </button>
      <button type="button" onClick={() => { const n = new Date(); setPeriod(n.getFullYear(), n.getMonth() + 1); }}
        data-testid="payroll-period-current" className="text-xs font-semibold text-slate-600 hover:text-slate-900 px-2 py-1.5 rounded-md hover:bg-slate-100">
        Bu Ay
      </button>
    </div>
  );
}
